/* ============================================================
   Punto C — custom JS (5OM · Webgas)
   Appiattisce il livello-intestazione dei menu (SHOP → CATEGORIE →
   prodotti diventa: CATEGORIE label + prodotti inline), così l'utente
   arriva ai prodotti in 1 passo — sia nel DRAWER mobile sia nel
   DROPDOWN desktop. Fedele ai dropdown del prototipo Figma.

   Robustezza: agisce solo se trova le classi Dawn. Se un update del
   tema le cambia, fa no-op e i menu tornano al comportamento nativo
   (nessuna rottura). Non modifica nessun file core del tema.
   ============================================================ */
(function () {
  function flatten(root, headingIdPrefix, panelSelector, headingClass) {
    if (!root) return;
    var headings = root.querySelectorAll('[id^="' + headingIdPrefix + '"]');
    Array.prototype.forEach.call(headings, function (l2) {
      var summary = l2.querySelector(':scope > summary');
      var panel = l2.querySelector(':scope > ' + panelSelector);
      var li = l2.closest('li');
      if (!summary || !panel || !li || !li.parentElement) return;
      var ul = li.parentElement;

      var parentDetails = l2.parentElement.closest('details');
      var parentSummary = parentDetails && parentDetails.querySelector(':scope > summary');
      var parentTitle = (parentSummary ? parentSummary.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
      var headingText = (summary.textContent || '').replace(/\s+/g, ' ').trim();

      // Intestazione come label statica — salvo quando duplica il titolo del genitore.
      if (headingText && headingText.toLowerCase() !== parentTitle) {
        var h = document.createElement('li');
        h.className = headingClass;
        h.setAttribute('role', 'presentation');
        h.textContent = headingText;
        ul.insertBefore(h, li);
      }

      // Sposta i link inline nel pannello del genitore.
      var items = panel.querySelectorAll('li');
      Array.prototype.forEach.call(items, function (it) { ul.insertBefore(it, li); });

      li.remove();
    });
  }

  function run() {
    if (window.__pcMenuFlattened) return;
    // Mobile: drawer
    flatten(document.querySelector('.menu-drawer'), 'Details-menu-drawer-submenu-', '.menu-drawer__submenu', 'menu-drawer__heading-c');
    // Desktop: dropdown compatto
    flatten(document.querySelector('.header__inline-menu'), 'Details-HeaderSubMenu-', 'ul.header__submenu', 'header__heading-c');
    window.__pcMenuFlattened = true;
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();

/* ============================================================
   Punto C — Sticky add-to-cart mobile (5OM · Webgas)
   La barra fissa in basso NON duplica la logica del carrello:
   fa da PROXY al bottone ATC principale di Dawn (click -> stesso
   flusso: variante selezionata, AJAX, cart drawer). Sincronizza
   prezzo e stato disabled dal main. No-op se non trova gli elementi.
   ============================================================ */
(function () {
  function initSticky() {
    var bar = document.getElementById('pc-sticky-atc');
    if (!bar) return;

    // spostala come figlia diretta del <body>: dentro la sezione prodotto un
    // antenato con transform (animazioni scroll Dawn) rende position:fixed
    // relativo a quel box invece che al viewport -> la barra restava in mezzo
    // alla pagina con spazio vuoto sotto. Nel body si àncora al viewport.
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    // il bottone ATC principale di Dawn (evita il form "installment" Shop Pay
    // che ha anch'esso action="/cart/add" ma nessun bottone add)
    var mainBtn = document.querySelector('.product-form:not(.installment) .product-form__submit')
      || document.querySelector('.product-form__submit');
    var stickyBtn = bar.querySelector('.pc-sticky-atc__btn');
    if (!mainBtn || !stickyBtn) { bar.remove(); return; }

    // marca il body così la pagina riserva spazio in fondo (solo dove c'è la barra)
    document.body.classList.add('pc-has-sticky-atc');

    // click: in modalità avvisami apre il back-in-stock, altrimenti proxy dell'ATC
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.getAttribute('data-pc-notify') === '1') {
        if (window.pcOpenNotify) window.pcOpenNotify();
        return;
      }
      mainBtn.click();
    });

    // sincronizza lo stato disabled (ma in modalità avvisami resta attivo)
    var syncBtn = function () {
      if (stickyBtn.getAttribute('data-pc-notify') === '1') { stickyBtn.disabled = false; return; }
      var off = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = off;
    };
    syncBtn();
    new MutationObserver(syncBtn).observe(mainBtn, {
      attributes: true, attributeFilter: ['disabled', 'aria-disabled']
    });

    // sincronizza il prezzo quando cambia la variante
    var mainPrice = document.querySelector('.product__info-container .price, .price');
    var stickyPrice = bar.querySelector('[data-pc-sticky-price]');
    if (mainPrice && stickyPrice) {
      var syncPrice = function () { stickyPrice.innerHTML = mainPrice.innerHTML; };
      new MutationObserver(syncPrice).observe(mainPrice, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  if (document.readyState !== 'loading') initSticky();
  else document.addEventListener('DOMContentLoaded', initSticky);
})();

/* ============================================================
   Punto C — Cart notification arricchito (5OM · Webgas)
   UPDATE-SAFE: nessuna modifica ai file core di Dawn. Inietta a
   runtime, dentro il notification nativo, la BARRA SPEDIZIONE
   GRATUITA e "POTREBBE PIACERTI ANCHE"; aggiunge qtà+prezzo alla
   riga. Sposta il <cart-notification> come figlio del <body> per
   il bottom-sheet mobile / box desktop (evita il transform dello
   sticky-header). No-op su errori -> resta il notification nativo.
   ============================================================ */
(function () {
  var FREE_SHIP_CENTS = 10000; // soglia spedizione gratuita Italia = 100€

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initCartNotif() {
    var wrapper = document.querySelector('cart-notification');
    var notif = document.getElementById('cart-notification');
    if (!wrapper || !notif) return;

    // fuori dallo sticky-header (transform) -> figlio diretto del body,
    // così position:fixed è relativo al viewport (bottom-sheet / box).
    if (wrapper.parentElement !== document.body) document.body.appendChild(wrapper);

    var lastProductId = null;

    new MutationObserver(function () {
      if (notif.classList.contains('active')) enhance();
    }).observe(notif, { attributes: true, attributeFilter: ['class'] });

    function enhance() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderFreeShip(cart);
          enrichRow(cart);
          renderRecs(cart);
        })
        .catch(function () {});
    }

    function getBox(cls, beforeSel) {
      var box = notif.querySelector('.' + cls);
      if (!box) {
        box = document.createElement('div');
        box.className = cls;
        var ref = beforeSel && notif.querySelector(beforeSel);
        if (ref && ref.parentNode) ref.parentNode.insertBefore(box, ref);
        else notif.appendChild(box);
      }
      return box;
    }

    function renderFreeShip(cart) {
      var box = getBox('pc-cn-freeship', '.cart-notification__links');
      if (window.pcScala && window.pcScala.cfg.active) {   // scala premi agosto 2026
        box.className = 'pc-cn-freeship pc-scala pc-scala--cn';
        window.pcScala.render(cart, box);
        return;
      }
      var total = cart.total_price;
      if (total >= FREE_SHIP_CENTS) {
        box.className = 'pc-cn-freeship is-unlocked';
        box.innerHTML =
          '<p class="pc-cn-freeship__label"><span class="pc-cn-check">✓</span> SPEDIZIONE GRATUITA SBLOCCATA</p>' +
          '<div class="pc-cn-freeship__bar"><span style="width:100%"></span></div>';
      } else {
        var pct = Math.max(4, Math.round((total / FREE_SHIP_CENTS) * 100));
        box.className = 'pc-cn-freeship';
        box.innerHTML =
          '<p class="pc-cn-freeship__label">Ti mancano <strong>' + money(FREE_SHIP_CENTS - total) +
          '</strong> alla spedizione gratuita</p>' +
          '<div class="pc-cn-freeship__bar"><span style="width:' + pct + '%"></span></div>';
      }
    }

    function enrichRow(cart) {
      var row = notif.querySelector('#cart-notification-product .cart-item');
      if (!row || row.querySelector('.pc-cn-line-price')) return;
      var key = (row.id || '').replace('cart-notification-product-', '');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) item = cart.items[cart.items.length - 1];
      if (!item) return;
      var info = row.querySelector('div:not(.cart-notification-product__image)');
      if (info) {
        var meta = document.createElement('p');
        meta.className = 'pc-cn-meta';
        meta.textContent = 'Qtà ' + item.quantity;
        info.appendChild(meta);
      }
      var price = document.createElement('span');
      price.className = 'pc-cn-line-price';
      price.textContent = money(item.final_line_price);
      row.appendChild(price);
    }

    function renderRecs(cart) {
      var box = getBox('pc-cn-recs');
      var pid = cart.items.length ? cart.items[cart.items.length - 1].product_id : null;
      if (!pid) { box.hidden = true; return; }
      if (pid === lastProductId && box.getAttribute('data-filled')) { box.hidden = false; return; }
      lastProductId = pid;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=3&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var recs = (data.products || []).slice(0, 3);
          if (!recs.length) { box.hidden = true; return; }
          box.hidden = false;
          box.setAttribute('data-filled', '1');
          box.innerHTML =
            '<p class="pc-cn-recs__title">POTREBBE PIACERTI ANCHE</p>' +
            '<div class="pc-cn-recs__grid">' +
            recs.map(function (p) {
              var img = p.featured_image || (p.images && p.images[0]) || '';
              return '<a class="pc-cn-rec" href="' + p.url + '">' +
                (img ? '<span class="pc-cn-rec__img"><img src="' + img + '" alt="" loading="lazy"></span>' : '') +
                '<span class="pc-cn-rec__t">' + p.title + '</span>' +
                '<span class="pc-cn-rec__p">' + money(p.price) + '</span></a>';
            }).join('') +
            '</div>';
        })
        .catch(function () { box.hidden = true; });
    }
  }

  if (document.readyState !== 'loading') initCartNotif();
  else document.addEventListener('DOMContentLoaded', initCartNotif);
})();

/* ============================================================
   Punto C — Box disponibilità PER-VARIANTE (5OM · Webgas)
   Aggiorna "SOLO X PEZZI RIMASTI" / ESAURITO / DROP LIMITATO in base
   alla TAGLIA selezionata, leggendo la mappa stato-per-variante generata
   da pc-stock-state.liquid. No-op se non trova gli elementi.
   ============================================================ */
(function () {
  var BELL = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3a4.5 4.5 0 0 0-4.5 4.5c0 4-1.5 5-1.5 5h12s-1.5-1-1.5-5A4.5 4.5 0 0 0 10 3Z"/><path d="M8.5 15.5a1.5 1.5 0 0 0 3 0"/></svg>';
  var PLUS = '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>';

  // Azione AVVISAMI: apre un POPUP MODALE con il form back-in-stock (overlay che
  // oscura la pagina). L'iscrizione va all'API client Klaviyo. Il bottone grande
  // e lo sticky mobile inoltrano entrambi qui.
  function pcMoveModal(modal) {
    // sposta il modale come figlio del <body>: un antenato con transform romperebbe
    // il position:fixed dell'overlay (come sticky/cart-notif).
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    if (!modal.getAttribute('data-pc-bound')) {
      modal.setAttribute('data-pc-bound', '1');
      var closers = modal.querySelectorAll('[data-pc-notify-close]');
      for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', pcCloseModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) pcCloseModal(); });
      var f = modal.querySelector('[data-pc-notify-form]');
      if (f) f.addEventListener('submit', pcNotifySubmit);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pcCloseModal(); });
    }
  }
  var pcCloseTimer = null;
  // mostra lo stato richiesto ('form' o 'done'), nasconde l'altro
  function pcSetState(modal, state) {
    var states = modal.querySelectorAll('[data-pc-notify-state]');
    for (var i = 0; i < states.length; i++) {
      states[i].hidden = states[i].getAttribute('data-pc-notify-state') !== state;
    }
  }
  function pcCloseModal() {
    var modal = document.querySelector('[data-pc-notify-modal]');
    if (!modal) return;
    if (pcCloseTimer) { clearTimeout(pcCloseTimer); pcCloseTimer = null; }
    modal.hidden = true;
    document.body.classList.remove('pc-modal-open');
  }
  window.pcOpenNotify = function () {
    var modal = document.querySelector('[data-pc-notify-modal]');
    if (!modal) {
      if (window.klaviyo && window.klaviyo.push) { try { window.klaviyo.push(['openBackInStock']); } catch (e) {} }
      return;
    }
    pcMoveModal(modal);
    if (pcCloseTimer) { clearTimeout(pcCloseTimer); pcCloseTimer = null; }
    // riparti sempre dallo stato form
    pcSetState(modal, 'form');
    var rf = modal.querySelector('[data-pc-notify-form]');
    if (rf) {
      var ri = rf.querySelector('.pc-notify-form__input'), rs = rf.querySelector('.pc-notify-form__submit'), rm = rf.querySelector('[data-pc-notify-msg]');
      if (ri) { ri.value = ''; }
      if (rs) { rs.disabled = false; }
      if (rm) { rm.hidden = true; }
    }
    modal.hidden = false;
    document.body.classList.add('pc-modal-open');
    var inp0 = modal.querySelector('.pc-notify-form__input');
    if (inp0) setTimeout(function () { inp0.focus(); }, 40);
  };

  // iscrizione back-in-stock via API client Klaviyo (company_id pubblico, no key)
  var PC_KLAVIYO_COMPANY = 'Yg2APv';
  function pcVariantId() {
    var el = document.querySelector('.product-form:not(.installment) [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]')
      || document.querySelector('[name="id"]');
    return el ? el.value : null;
  }
  function pcNotifySubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var inp = form.querySelector('.pc-notify-form__input');
    var sub = form.querySelector('.pc-notify-form__submit');
    var msg = form.querySelector('[data-pc-notify-msg]');
    var email = ((inp && inp.value) || '').trim();
    var variant = pcVariantId();
    if (!email || !variant) return;
    if (sub) sub.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + PC_KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } })
    }).then(function (r) {
      if (r.status === 202 || r.ok) {
        var mdl = form.closest('[data-pc-notify-modal]');
        if (mdl) pcSetState(mdl, 'done');
        pcCloseTimer = setTimeout(pcCloseModal, 5500);
      } else {
        if (sub) sub.disabled = false;
        if (msg) { msg.textContent = 'Qualcosa non ha funzionato, riprova.'; msg.hidden = false; }
      }
    }).catch(function () {
      if (sub) sub.disabled = false;
      if (msg) { msg.textContent = 'Errore di rete, riprova.'; msg.hidden = false; }
    });
  }

  // scambia ATC <-> AVVISAMI (bottone grande + sticky) in base allo stato esaurito
  function toggleNotify(esaurito) {
    var big = document.querySelector('[data-pc-notify-btn]');
    if (big) {
      big.classList.toggle('pc-notify-btn--show', esaurito);
      if (!big.getAttribute('data-pc-bound')) {
        big.setAttribute('data-pc-bound', '1');
        big.addEventListener('click', function () { if (window.pcOpenNotify) window.pcOpenNotify(); });
      }
    }
    document.body.classList.toggle('pc-atc-hidden', esaurito);
    var sBtn = document.querySelector('#pc-sticky-atc .pc-sticky-atc__btn');
    if (sBtn) {
      if (esaurito) {
        sBtn.setAttribute('data-pc-notify', '1');
        sBtn.disabled = false;
        sBtn.innerHTML = BELL + '<span>AVVISAMI</span>';
      } else if (sBtn.getAttribute('data-pc-notify') === '1') {
        sBtn.removeAttribute('data-pc-notify');
        sBtn.innerHTML = PLUS + '<span>AGGIUNGI</span>';
      }
    }
  }

  function initAvailbox() {
    var wrap = document.querySelector('[data-pc-availbox]');
    var mapEl = document.querySelector('[data-pc-availbox-map]');
    if (!wrap || !mapEl) return;

    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    function currentVariantId() {
      // l'input nascosto [name="id"] del form prodotto viene aggiornato da Dawn
      var inputs = document.querySelectorAll('[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value && map.hasOwnProperty(inputs[i].value)) return inputs[i].value;
      }
      return null;
    }

    function render() {
      var id = currentVariantId();
      var d = id ? map[id] : null;
      if (!d) {
        wrap.innerHTML = '';
      } else {
        wrap.innerHTML =
          '<div class="pc-availbox pc-availbox--' + d.s + '">' +
          '<p class="pc-availbox__t1"><span class="pc-availbox__dot" aria-hidden="true"></span>' + d.t1 + '</p>' +
          (d.t2 ? '<p class="pc-availbox__t2">' + d.t2 + '</p>' : '') + '</div>';
      }
      // stato esaurito -> mostra AVVISAMI (grande + sticky), nasconde l'ATC
      toggleNotify(!!(d && d.s === 'esaurito'));
    }

    // la variante cambia -> Dawn ri-renderizza il prezzo: lo osservo come segnale
    var price = document.querySelector('.product__info-container .price, .price');
    if (price) {
      new MutationObserver(render).observe(price, {
        childList: true, subtree: true, characterData: true
      });
    }
    // e ascolto anche il change diretto sui selettori taglia
    document.querySelectorAll('.product-form__input input[type="radio"], variant-selects select, variant-radios input').forEach(function (el) {
      el.addEventListener('change', function () { setTimeout(render, 0); });
    });

    render();
  }

  if (document.readyState !== 'loading') initAvailbox();
  else document.addEventListener('DOMContentLoaded', initAvailbox);
})();

/* ============================================================
   Punto C — Centra il widget Scalapay nel carrello (5OM · Webgas)
   Il testo Scalapay vive in shadow DOM ANNIDATI: il CSS normale non
   ci arriva, quindi si inietta lo stile dentro ogni shadow root.
   Si ri-applica al re-render del footer (cambio quantità). No-op se
   la struttura del widget cambia -> nessuna rottura (torna a sinistra).
   ============================================================ */
(function () {
  function centerScalapay() {
    var host = document.querySelector('#scalapay-cart-page-widget scalapay-widget');
    if (!host || !host.shadowRoot) return false;
    var css = '*{justify-content:center !important;text-align:center !important;}';
    var did = false;
    (function inject(root) {
      if (!root) return;
      if (!root.querySelector('style[data-pc-scala]')) {
        var s = document.createElement('style');
        s.setAttribute('data-pc-scala', '1');
        s.textContent = css;
        root.appendChild(s);
        did = true;
      }
      root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) inject(el.shadowRoot); });
    })(host.shadowRoot);
    return did;
  }

  function initScala() {
    if (!document.querySelector('#scalapay-cart-page-widget')) return; // solo pagina carrello
    var tries = 0;
    var iv = setInterval(function () { if (centerScalapay() || ++tries > 40) clearInterval(iv); }, 250);
    var footer = document.querySelector('#main-cart-footer') || document.body;
    new MutationObserver(function () { setTimeout(centerScalapay, 300); })
      .observe(footer, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') initScala();
  else document.addEventListener('DOMContentLoaded', initScala);
})();

/* Punto C — Cart "Completa l'ordine": seleziona dai best-seller i prodotti che
   avvicinano di piu' alla soglia spedizione gratuita. Aggiorna a ogni modifica
   del carrello. Markup renderizzato dalla sezione cart-completa-ordine.liquid. */
(function () {
  function finish(box, count) {
    var section = box.closest('[data-pc-cross-section]');
    if (section) section.style.display = count ? '' : 'none';
  }

  function rankAndShow(box, cart) {
    var threshold = parseInt(box.dataset.threshold, 10) || 0;
    var show = parseInt(box.dataset.show, 10) || 4;
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-cross-item]'));
    if (!items.length) return finish(box, 0);

    var total = cart ? cart.total_price : 0;
    var missing = Math.max(0, threshold - total);
    var inCart = {};
    if (cart && cart.items) cart.items.forEach(function (i) { inCart[String(i.product_id)] = true; });

    var pool = items.filter(function (el) { return !inCart[el.dataset.productId]; });
    var ranked;
    if (missing > 0) {
      // obiettivo: RAGGIUNGERE i 100 euro (spedizione gratuita).
      // 1) prodotti che sbloccano la soglia (prezzo >= mancante), ordinati ASC:
      //    quelli che raggiungono i 100 col minimo extra vengono per primi.
      var unlock = pool.filter(function (el) { return (+el.dataset.price) >= missing; })
        .sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
      // 2) se non bastano, riempi con quelli che NON sbloccano (prezzo < mancante),
      //    ordinati DESC: quelli che avvicinano di piu' al traguardo.
      var fill = pool.filter(function (el) { return (+el.dataset.price) < missing; })
        .sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
      ranked = unlock.concat(fill);
    } else {
      ranked = pool; // gia' oltre soglia: best-seller assoluti (ordine gia' best-selling)
    }

    items.forEach(function (el) { el.style.display = 'none'; });
    var chosen = ranked.slice(0, show);
    chosen.forEach(function (el) { el.style.display = ''; });
    finish(box, chosen.length);
  }

  function refresh() {
    var box = document.querySelector('[data-pc-cross]');
    if (!box) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { rankAndShow(box, cart); })
      .catch(function () { rankAndShow(box, null); });
  }

  function initCross() {
    var box = document.querySelector('[data-pc-cross]');
    if (!box) return; // solo dove c'e' la sezione (pagina carrello)
    refresh();
    var cartRoot = document.querySelector('cart-items') || document.getElementById('main-cart-items') || document.body;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 350); })
      .observe(cartRoot, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') initCross();
  else document.addEventListener('DOMContentLoaded', initCross);
})();

/* Punto C — nasconde il bottone AUTO back-in-stock di Klaviyo: usiamo il nostro
   bottone AVVISAMI + mini-form (API client). Il bottone Klaviyo ha classi offuscate
   (kl-private-reset-css), lo individuiamo per testo. Observer per l'iniezione async. */
(function () {
  function hide() {
    var els = document.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (/back in stock/i.test(el.textContent || '') && /kl-private|needsclick/.test((el.className || '').toString())) {
        var c = el.closest('div[class*="kl-private"]') || el.parentElement || el;
        if (c && c.style.display !== 'none') c.style.display = 'none';
      }
    }
  }
  function init() {
    hide();
    var n = 0, iv = setInterval(function () { hide(); if (++n > 24) clearInterval(iv); }, 400);
    try { new MutationObserver(hide).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Punto C — Klaviyo identify bridge (5OM · Webgas)
   Gli eventi onsite di Klaviyo (Added to Cart, ecc.) partono SOLO per
   browser IDENTIFICATI. Su 5OM nessun form identifica il browser verso
   Klaviyo (newsletter = Shopify Forms; community = GetSiteControl),
   quindi gli eventi onsite non venivano mai inviati. Questo modulo
   identifica il browser appena abbiamo un'email:
     1) cliente Shopify loggato -> window.pcCustomerEmail (da theme.liquid);
     2) submit del popup newsletter Shopify Forms -> email digitata,
        letta dallo shadow DOM (data-testid="field-email") al click su
        "Iscriviti ora" (data-testid="btn-form-submit").
   Validato empiricamente end-to-end su live e staging (identify ->
   /client/profiles -> profilo creato). No-op difensivo: se manca klaviyo
   o l'email non e' valida, non fa nulla. NB: il ramo "Continua con Shop"
   non digita l'email -> non copribile qui (si auto-identifica quando
   l'utente clicca una email Klaviyo).
   ============================================================ */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var lastId = null;

  function identify(email) {
    if (!email || !EMAIL_RE.test(email)) return;
    if (email === lastId) return; // evita doppioni nella stessa pagina
    if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
    try { window.klaviyo.push(['identify', { '$email': email }]); lastId = email; } catch (e) {}
  }

  // Legge l'email dal popup Shopify Forms bucando gli shadow DOM annidati.
  function readFormsEmail() {
    function walk(root) {
      var acc = [];
      if (root.shadowRoot) acc = acc.concat(walk(root.shadowRoot));
      var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var i = 0; i < els.length; i++) { acc.push(els[i]); if (els[i].shadowRoot) acc = acc.concat(walk(els[i].shadowRoot)); }
      return acc;
    }
    var all = walk(document);
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.tagName === 'INPUT' &&
          ((el.getAttribute && el.getAttribute('data-testid') === 'field-email') || el.type === 'email') &&
          el.value && EMAIL_RE.test(el.value)) return el.value;
    }
    return null;
  }

  // 1) Cliente Shopify loggato: identifica subito.
  if (window.pcCustomerEmail) identify(window.pcCustomerEmail);

  // 2) Submit del popup newsletter (Shopify Forms): identifica con l'email digitata.
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var isSubmit = path.some(function (n) {
      return n && n.getAttribute && (n.getAttribute('data-testid') === 'btn-form-submit' ||
        (n.tagName === 'BUTTON' && /iscriviti ora/i.test(n.textContent || '')));
    });
    if (isSubmit) { var email = readFormsEmail(); if (email) identify(email); }
  }, true);
})();

/* ============================================================
   Punto C — Newsletter -> Klaviyo (routing per lingua 5OM)
   La sezione newsletter Dawn usa il form cliente Shopify (post a
   Shopify, lista unica, nessun routing). Qui intercettiamo il
   submit e iscriviamo alla LISTA Klaviyo giusta in base alla
   lingua dello store: IT->Newsletter|IT, EN->|EN, DE->|DE.
   Update-safe: nessuna modifica ai file core; no-op se il form
   non c'e'. Coesiste col bridge identify (non fa stopPropagation).
   ============================================================ */
(function () {
  var COMPANY = 'Yg2APv';
  var LISTS = { it: 'SnTYGW', en: 'R8RTtG', de: 'YdWbae' };
  function pcNlLocale() { return (document.documentElement.getAttribute('lang') || 'it').slice(0, 2).toLowerCase(); }
  function pcNlList() { return LISTS[pcNlLocale()] || LISTS.en; } // fallback lista internazionale (EN)
  var NL_MSG = {
    it: { ok: 'Iscrizione ricevuta! Controlla la tua email.', err: 'Qualcosa non ha funzionato, riprova.', net: 'Errore di rete, riprova.' },
    en: { ok: "You're in! Check your inbox to confirm.", err: 'Something went wrong, please try again.', net: 'Network error, please try again.' },
    de: { ok: 'Fast geschafft! Bitte bestätige es in deiner E-Mail.', err: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.', net: 'Netzwerkfehler. Bitte versuche es erneut.' }
  };
  function pcNlT() { return NL_MSG[pcNlLocale()] || NL_MSG.en; }
  function pcNlMsg(form, text) {
    var wrap = form.querySelector('.newsletter-form__field-wrapper');
    if (wrap) wrap.hidden = true;
    var m = form.querySelector('[data-pc-nl-msg]');
    if (!m) {
      m = document.createElement('p');
      m.setAttribute('data-pc-nl-msg', '1');
      m.className = 'newsletter-form__message form__message';
      form.appendChild(m);
    }
    m.hidden = false;
    m.textContent = text;
  }
  function pcNlError(form, btn, text) {
    if (btn) btn.disabled = false;
    var m = form.querySelector('[data-pc-nl-msg]');
    if (m) m.hidden = true;
    var wrap = form.querySelector('.newsletter-form__field-wrapper');
    if (wrap) wrap.hidden = false;
    var e = form.querySelector('[data-pc-nl-err]');
    if (!e) {
      e = document.createElement('small');
      e.setAttribute('data-pc-nl-err', '1');
      e.className = 'newsletter-form__message form__message';
      (wrap || form).appendChild(e);
    }
    e.textContent = text;
  }
  function pcNlSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var inp = form.querySelector('input[type="email"]');
    var email = ((inp && inp.value) || '').trim();
    if (!email) return;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Newsletter home', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: pcNlList() } } } } })
    }).then(function (r) {
      if (r.status === 202 || r.ok) pcNlMsg(form, pcNlT().ok);
      else pcNlError(form, btn, pcNlT().err);
    }).catch(function () { pcNlError(form, btn, pcNlT().net); });
  }
  function pcNlInit() {
    var forms = document.querySelectorAll('.newsletter-form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].getAttribute('data-pc-nl')) continue;
      forms[i].setAttribute('data-pc-nl', '1');
      forms[i].addEventListener('submit', pcNlSubmit);
    }
  }
  if (document.readyState !== 'loading') pcNlInit();
  else document.addEventListener('DOMContentLoaded', pcNlInit);
})();

/* ============================================================
   Scala premi agosto 2026 (5OM · Webgas) — v2 hardened
   - renderer unico della barra a tappe (mini-cart + pagina carrello)
   - basketball auto-add sopra i 100 € di merce, auto-remove sotto
   Config server-side in #pc-scala-config (snippets/pc-scala-config.liquid).
   HARDENING: lo stato "attivo" (percentuale, palla) viene dagli SCONTI
   REALMENTE APPLICATI in /cart.js (riga ordine "Scala premi -N%", palla
   con final_line_price 0), mai dalle soglie: se Shopify non applica, la
   barra non lo promette. Le soglie servono solo per i "ti mancano X €".
   Base importi = items_subtotal_price ESCLUSA la palla. La palla comprata
   a mano sotto soglia è un acquisto normale: non la tocchiamo mai.
   ============================================================ */
(function () {
  var el = document.getElementById('pc-scala-config');
  if (!el) return;
  var CFG; try { CFG = JSON.parse(el.textContent); } catch (e) { return; }
  if (!CFG.active) return;

  var MAX = 40000;

  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function goods(cart) {  // merce esclusa la palla
    var g = cart.items_subtotal_price;
    cart.items.forEach(function (i) { if (i.handle === CFG.ballHandle) g -= i.final_line_price; });
    return g;
  }

  function applied(cart) {  // cosa è DAVVERO applicato
    var pct = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var m = /Scala premi -(\d+)%/.exec(d.title || '');
      if (m) pct = Math.max(pct, parseInt(m[1], 10));
    });
    var ballFree = cart.items.some(function (i) {
      return i.handle === CFG.ballHandle && i.quantity > 0 && i.final_line_price === 0;
    });
    return { pct: pct, ballFree: ballFree };
  }

  function milestones() {
    var ms = [{ at: CFG.ballAt, kind: 'ball',
                lab: CFG.zone === 'it' ? CFG.s.lab_ball_ship : CFG.s.lab_ball,
                alt: CFG.zone === 'it' }];
    CFG.tiers.forEach(function (t, i) {
      var lab = '−' + CFG.pcts[i] + '%';
      if (CFG.zone === 'usca' && t === 30000) lab = CFG.s.lab_tier_ship;
      if (CFG.zone === 'row' && t === 40000) lab = CFG.s.lab_max_ship;
      ms.push({ at: t, kind: 'tier', pct: CFG.pcts[i], lab: lab, alt: false });
    });
    if (CFG.zone === 'eu') ms.push({ at: CFG.shipAt, kind: 'ship', lab: CFG.s.lab_ship, alt: true });
    ms.sort(function (a, b) { return a.at - b.at; });
    return ms;
  }

  function message(g, ap) {
    var s = CFG.s, z = CFG.zone;
    function f(str, x, p, n) {
      return str.replace('__X__', '<strong>' + money(x) + '</strong>')
                .replace('__P__', p).replace('__N__', n);
    }
    if (ap.pct >= 25) return z === 'row' ? s.max_ship : s.max;
    if (ap.pct === 20) {
      var x25 = 40000 - g;
      var str20 = z === 'usca' ? s.tier_ship_active : (z === 'row' ? s.tier_to_max_ship : s.tier_active);
      if (x25 <= 0) return f(s.tier_active, 0, 20, 25).split('·')[0].trim();
      return f(str20, x25, 20, 25);
    }
    if (ap.pct === 15) {
      if (z === 'eu' && g < 25000) return f(s.tier_to_ship, 25000 - g);
      if (z === 'eu' && g < 30000) return f(s.ship_to_tier, 30000 - g);
      var x20 = 30000 - g;
      if (x20 <= 0) return f(s.tier_active, 0, 15, 20).split('·')[0].trim();
      return f(s.tier_active, x20, 15, 20);
    }
    if (ap.pct === 10) {
      var x15 = 22000 - g;
      if (x15 <= 0) return f(s.tier_active, 0, 10, 15).split('·')[0].trim();
      return f(s.tier_active, x15, 10, 15);
    }
    // nessuna percentuale applicata
    if (ap.ballFree) {
      var x10 = 15000 - g;
      if (x10 <= 0) return s.ball_done.split('!')[0] + '!';
      return f(s.ball_done, x10);
    }
    var xb = CFG.ballAt - g;
    if (xb <= 0) return f(s.ball_done, Math.max(15000 - g, 0));  // soglia passata, palla non (ancora) in carrello
    return f(z === 'it' ? s.to_ball_ship : s.to_ball, xb);
  }

  function render(cart, box) {
    var g = goods(cart);
    var ap = applied(cart);
    var pct = Math.min(100, Math.max(3, Math.round(g / MAX * 100)));
    var ticks = milestones().map(function (m) {
      var on = m.kind === 'ball' ? ap.ballFree :
               m.kind === 'tier' ? ap.pct >= m.pct : g >= m.at;
      var left = Math.min(100, Math.round(m.at / MAX * 1000) / 10);
      return '<span class="pc-scala__tick' + (on ? ' pc-scala__tick--on' : '') +
             '" style="left:' + left + '%"><span class="pc-scala__lab' +
             (m.alt ? ' pc-scala__lab--alt' : '') + '">' + m.lab + '</span></span>';
    }).join('');
    // due righe: stato · obiettivo (split su "·", o su "!" per "sbloccato!")
    var msg = message(g, ap), riga1 = msg, riga2 = '';
    if (msg.indexOf('·') > -1) {
      riga1 = msg.split('·')[0].trim();
      riga2 = msg.split('·').slice(1).join('·').trim();
    } else if (msg.indexOf('! ') > -1) {
      riga1 = msg.split('! ')[0] + '!';
      riga2 = msg.split('! ').slice(1).join('! ').trim();
    }
    box.innerHTML = '<p class="pc-scala__msg">' + riga1 + '</p>' +
      (riga2 ? '<p class="pc-scala__next">' + riga2 + '</p>' : '') +
      '<div class="pc-scala__rail"><span class="pc-scala__fill" style="width:' + pct + '%"></span>' +
      ticks + '</div>';
  }

  window.pcScala = { cfg: CFG, render: render, goods: goods, applied: applied };

  /* ---- barra nella pagina carrello ---- */
  function initCartPage() {
    if (!document.querySelector('[data-pc-scala]')) return;
    var timer = null;
    var refresh = function () {
      var box = document.querySelector('[data-pc-scala]');   // ri-cercato: Dawn lo rimpiazza
      if (!box) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart, box); })
        .catch(function () {});
    };
    var schedule = function () { clearTimeout(timer); timer = setTimeout(refresh, 120); };
    refresh();
    window.addEventListener('pc:cart-changed', schedule);
    // Dawn ri-renderizza il footer (Section Rendering API) a ogni cambio quantita'/rimozione:
    // il contenitore torna vuoto -> lo ri-popoliamo appena riappare nel DOM.
    var footer = document.getElementById('main-cart-footer') || document.body;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-pc-scala]')) ||
              (n.querySelector && n.querySelector('[data-pc-scala]'))) { schedule(); return; }
        }
      }
    }).observe(footer, { childList: true, subtree: true });
  }

  /* ---- basketball automatico ---- */
  var OPTOUT = 'pc-scala-ball-optout';   // tolto a mano sopra soglia: non re-inserire
  var AUTO = 'pc-scala-ball-auto';       // l'abbiamo messo noi (solo quello rimuoviamo)
  var PRES = 'pc-scala-ball-present';
  var busy = false;

  function mutate(path, body, done) {
    busy = true;
    fetch(path, { method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function () { done && done(); })
      .catch(function () {})
      .finally(function () {
        busy = false;
        window.dispatchEvent(new Event('pc:cart-changed'));
        refreshBits();
      });
  }

  function refreshBits() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section');
          bubble.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
        }
      }).catch(function () {});
  }

  function reconcile() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var g = goods(cart);
        var ball = cart.items.filter(function (i) { return i.handle === CFG.ballHandle; })[0];
        var had = sessionStorage.getItem(PRES) === '1';
        sessionStorage.setItem(PRES, ball ? '1' : '0');
        if (g < CFG.ballAt) {
          sessionStorage.removeItem(OPTOUT);   // sotto soglia l'opt-out si resetta
          if (ball && sessionStorage.getItem(AUTO) === '1') {
            mutate('/cart/change.js', { id: ball.key, quantity: 0 }, function () {
              sessionStorage.setItem(AUTO, '0'); sessionStorage.setItem(PRES, '0');
            });
          }
          return;
        }
        if (!ball) {
          if (had) { sessionStorage.setItem(OPTOUT, '1'); sessionStorage.setItem(AUTO, '0'); return; }
          if (sessionStorage.getItem(OPTOUT) === '1') return;
          mutate('/cart/add.js', { id: CFG.ballVariant, quantity: 1 }, function () {
            sessionStorage.setItem(AUTO, '1'); sessionStorage.setItem(PRES, '1');
          });
        }
      }).catch(function () {});
  }

  /* intercetta le mutazioni carrello del tema */
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { if (!busy) setTimeout(reconcile, 80); });
    }
    return p;
  };

  function boot() { initCartPage(); reconcile(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* ============================================================
   Poster Omaggio Outlet (5OM · Webgas)
   Chi ha almeno 1 articolo della collezione Outlet nel carrello riceve
   automaticamente 1 Poster Omaggio (prodotto a 0 €). Se toglie tutti gli
   articoli Outlet, il poster esce da solo.
   Config server-side in #pc-poster-config (snippets/pc-poster-omaggio-config.liquid).

   Appartenenza alla collezione: /cart.js non espone ne' le collezioni ne'
   compare_at_price, quindi gli id Outlet arrivano da /collections/<h>?view=ids
   (templates/collection.ids.liquid) — una sola richiesta, poi in sessionStorage.

   Differenza voluta rispetto alla palla della scala premi: la palla comprata a
   mano e' un acquisto normale e non si tocca; il poster vale 0 € e non deve
   essere ottenibile senza Outlet, quindi senza Outlet lo togliamo SEMPRE, anche
   se non l'abbiamo aggiunto noi.
   ============================================================ */
(function () {
  var DBG = window.__pcPoster = { step: 'start' };
  var el = document.getElementById('pc-poster-config');
  if (!el) { DBG.step = 'no-config-el'; return; }
  var CFG; try { CFG = JSON.parse(el.textContent); } catch (e) { DBG.step = 'config-parse-fail'; return; }
  if (!CFG.active || !CFG.posterVariant) { DBG.step = 'inactive'; return; }
  DBG.step = 'armed';
  DBG.cfg = CFG;

  var OPTOUT = 'pc-poster-optout';   // tolto a mano avendo Outlet: non re-inserire
  var AUTO   = 'pc-poster-auto';     // l'abbiamo messo noi
  var PRES   = 'pc-poster-present';  // c'era al giro precedente
  var IDS    = 'pc-outlet-ids';
  var busy = false;
  var ids = null;
  var mem = {};   // fallback quando sessionStorage e' inaccessibile (cookie di terze parti bloccati)

  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return mem[k] || null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) { delete mem[k]; } }

  function outletIds(cb) {
    if (ids) return cb(ids);
    var c = ss(IDS);
    if (c) { try { ids = JSON.parse(c); return cb(ids); } catch (e) {} }
    // niente header Accept: con `Accept: text/plain` Shopify risponde 404 al template
    // alternativo (content negotiation). Va lasciato l'Accept di default del browser.
    fetch('/collections/' + CFG.outletHandle + '?view=ids')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var parsed = JSON.parse(t.trim());
        if (!Array.isArray(parsed) || !parsed.length) throw new Error('lista vuota');
        ids = parsed;
        ssSet(IDS, JSON.stringify(ids));
        cb(ids);
      })
      .catch(function (e) { DBG.idsErr = String(e); cb(null); });   // null = non lo sappiamo: non tocchiamo niente
  }

  function mutate(path, body, done) {
    busy = true;
    fetch(path, { method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function () { done && done(); })
      .catch(function () {})
      .finally(function () {
        busy = false;
        window.dispatchEvent(new Event('pc:cart-changed'));
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
        else refreshBubble();
      });
  }

  function refreshBubble() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !sections['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
      }).catch(function () {});
  }

  function reconcile() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        outletIds(function (list) {
          DBG.ids = list ? list.length : null;
          if (!list) { DBG.step = 'no-ids'; return; }   // lista non disponibile: meglio non fare nulla che sbagliare
          var hasOutlet = cart.items.some(function (i) { return list.indexOf(i.product_id) !== -1; });
          var poster = cart.items.filter(function (i) { return i.product_id === CFG.posterProductId; })[0];

          // Spesa su cui si misura la soglia: subtotale gia' al netto degli sconti di riga,
          // meno il poster stesso (che vale 0, ma cosi' resta giusto anche se un domani
          // gli si desse un prezzo). Conta quanto il cliente spende davvero.
          var spesa = cart.items_subtotal_price;
          if (poster) spesa -= poster.final_line_price;
          var sopraSoglia = !CFG.minSubtotal || spesa >= CFG.minSubtotal;
          var idoneo = hasOutlet && sopraSoglia;
          var had = ss(PRES) === '1';
          ssSet(PRES, poster ? '1' : '0');
          DBG.step = 'reconciled'; DBG.hasOutlet = hasOutlet; DBG.poster = !!poster;
          DBG.spesa = spesa; DBG.sopraSoglia = sopraSoglia;

          if (poster && poster.quantity > CFG.max) {
            mutate('/cart/change.js', { id: poster.key, quantity: CFG.max });
            return;
          }

          if (!idoneo) {
            ssDel(OPTOUT);   // fuori dai requisiti l'opt-out si azzera
            if (poster) {
              mutate('/cart/change.js', { id: poster.key, quantity: 0 }, function () {
                ssSet(AUTO, '0'); ssSet(PRES, '0');
              });
            }
            return;
          }

          if (!poster) {
            if (had) { ssSet(OPTOUT, '1'); ssSet(AUTO, '0'); return; }
            if (ss(OPTOUT) === '1') return;
            // la property finisce anche nell'email d'ordine e nel packing slip:
            // e' li' che il magazzino legge "casuale" quando prepara la spedizione
            var body = { id: CFG.posterVariant, quantity: 1 };
            if (CFG.properties) body.properties = CFG.properties;
            mutate('/cart/add.js', body, function () {
              ssSet(AUTO, '1'); ssSet(PRES, '1');
            });
          }
        });
      }).catch(function () {});
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { if (!busy) setTimeout(reconcile, 80); });
    }
    return p;
  };

  if (document.readyState !== 'loading') reconcile();
  else document.addEventListener('DOMContentLoaded', reconcile);
})();
